import { useContext, useMemo, useState } from 'react';

import Popup from '../Popup/Popup';
import Button from '../Button/Button';
import { ButtonType, SnackbarType } from '../../types/enums';
import Input from '../Input/Input';
import { getDashboardUrlById, isValidEmail } from '../../utils/common';
import { sendDashboardByEmails } from '../../requests/requests';
import { NotificationContext } from '../../App';

import styles from './PushToTvPopup.module.scss';

interface PushToTvPopupProps {
  id: string;
  onCancel: () => void;
}

const PushToTvPopup = ({ onCancel, id }: PushToTvPopupProps) => {
  const notify = useContext(NotificationContext);
  const [mainButtonTitle, setMainButtonTitle] = useState('Copy link to clipboard');
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState(false);
  const url = useMemo(() => getDashboardUrlById(id), [id]);

  const onCopy = () => {
    navigator.clipboard.writeText(url).then(() => {
      setMainButtonTitle('Copied!');

      setTimeout(() => {
        setMainButtonTitle('Copy link to clipboard');
      }, 1500);
    });
  };

  const onEmail = () => {
    setEmailError(false);
    if (email.split(/[\s,]+/).every((it) => !isValidEmail(it))) {
      setEmailError(true);
      return;
    }

    sendDashboardByEmails(id, email.split(/[\s,]+/)).then(() => {
      notify('Link to dashboard sent!', SnackbarType.SUCCESS);
      onCancel();
    });
  };

  return (
    <Popup show onHide={onCancel} title="Share dashboard">
      <div>
        <p>Open this link in a browser to display the status page on any device.</p>
        <Input id="url" label="Shared URL:" value={url} readonly />
        <div>
          <Button type={ButtonType.PRIMARY} fullWidth action={onCopy}>
            {mainButtonTitle}
          </Button>
        </div>
        <div className={styles.separator}>
          <span>or</span>
        </div>
        <div>
          <p>Alternatively, share the link with your friends and colleagues via email.</p>
          <Input
            id="email"
            label="We'll email the link to the following people:"
            value={email}
            setValue={setEmail}
            placeholder="e.g. you@example.com, friend@example.com,"
            error={emailError ? 'Error: The field is required' : ''}
          />
          <Button type={ButtonType.PRIMARY_INVERSE} fullWidth action={onEmail}>
            Share Link via email
          </Button>
        </div>
      </div>
    </Popup>
  );
};

export default PushToTvPopup;
